import {DataTable, dateTime} from '@management-ui/core';
import {MTableToolbar} from '@material-table/core';
import {reverse} from 'named-urls';
import * as React from 'react';
import {useContext, useEffect, useMemo, useRef} from 'react';
import {useHistory} from 'react-router-dom';
import Filter from '../../../../components/Filter';
import InboxStatus from '../../../../components/MessageStatus';
import {ServiceContext} from '../../../../components/Services';
import withInboxCount from '../../../../components/withInboxCount';
import {useInboxStatuses, useQuery} from '../../../../hooks';
import routes from '../../../../routes';
import {API} from '../../../../services/API';

const Table = ({inboxCount}) => {
  const services = useContext(ServiceContext);
  const history = useHistory();
  const statuses = useInboxStatuses();

  /** @type {({current: DataTable})} */
  const tableRef = useRef();
  const refreshRef = useRef('');
  const {values: {status, page, pageSize}, changeQuery, changePage, initialised} = useQuery(useMemo(() => ({
    status: 'unread',
    page: '1',
    pageSize: '50',
    search: ''
  }), []));

  useEffect(() => {
    const key = JSON.stringify({status});
    if (initialised && refreshRef.current !== key && tableRef.current) {
      tableRef.current.refresh();
    }
    refreshRef.current = key;
  }, [status, initialised]);


  const countRef = useRef(inboxCount);

  useEffect(() => {
    if (initialised && inboxCount !== countRef.current) {
      if (['unread', 'all'].indexOf(status) >= 0) {
        tableRef.current.refresh();
      }
    }
    countRef.current = inboxCount;
  }, [inboxCount, status, initialised]);

  const tableProps = useMemo(() => ({
    tableProps: {
      components: {
        Toolbar: (props) => (
          <>
            <MTableToolbar {...props}/>
            <Filter
              statuses={statuses}
              status={status}
              onChangeStatus={changed => changeQuery({status: changed})}
            />
          </>
        )
      }
    },
    options: {
      initialPage: parseInt(page) - 1,
      pageSize: parseInt(pageSize),
      search: false
    },
    columns: [
      {title: 'Sender', field: 'sender'},
      {title: 'Subject', field: 'subject'},
      {title: 'Date', field: 'created_at', render: data => dateTime(data.created_at)},
      {
        title: 'Status',
        sorting: false,
        field: 'locked',
        render: item => <InboxStatus message={item}/>
      },
    ],
    loadData: query => new Promise((resolve, reject) => {
      const params = {};
      if (status !== 'all') {
        params[status] = '1';
      }
      changePage(API.getTableParams(query));
      services.inbox.getTableMessages(query, params)
        .then(response => {
          resolve({
            data: response.data, page: response.meta.current_page - 1, totalCount: response.meta.total
          });
        }).catch(() => reject());
    }),
    onRowClick: (message) => history.push(reverse(routes.inbox.detail, {id: message.id}))
  }), [services, history, statuses, status, page, pageSize, changeQuery, changePage]);

  return initialised ? (
    <DataTable
      ref={tableRef}
      title=""
      {...tableProps}
    />
  ) : null;
};

export default withInboxCount(Table);
